import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { BehaviorSubject, Subject, Unsubscribable } from 'rxjs';
import { IValueChangedEvent } from '../../../wizard.content';
import { cloneDeep, filter, get, uniq } from 'lodash';
import {
  IAlertListRow,
  ISeverityEnum,
  ITableObject,
  TimeoutWrapperService,
  TransformationService,
  ValuesExchangeProvider,
  ApplicationsService
} from '@nrwl/common-lib';
import { ViewTableComponent } from '@nrwl/view-table';

@Component({
  selector: 'wizard-email-application',
  templateUrl: './user.email.notification.component.html',
  styleUrls: ['./user.email.notification.style.scss'],
  providers: []
})
export class UserEmailNotificationComponent implements OnInit, OnDestroy {
  @ViewChild(ViewTableComponent, { static: true }) child: ViewTableComponent;
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  wizardService: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  dataSource: Subject<any>; //eslint-disable-line @typescript-eslint/no-explicit-any
  pageSize = 10;
  pageSizeOptions = [10];
  showPaginator: BehaviorSubject<boolean>;
  selectedRowIndex: BehaviorSubject<number>;
  searchText: BehaviorSubject<string>;
  dataSourceTableData: any = []; //eslint-disable-line @typescript-eslint/no-explicit-any
  userDefinedApps: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  appList: ITableObject;
  tableOptions = {
    hideActionsColumn: false
  };
  searchField = '';
  onTableRowClick: Function; // eslint-disable-line
  userDefinedAppList: ITableObject;
  exchangeUnsubscribe: Unsubscribable;

  constructor(
    readonly transformService: TransformationService,
    private readonly exchange: ValuesExchangeProvider,
    private readonly applicationsService: ApplicationsService,
    private readonly timeout: TimeoutWrapperService
  ) {
    this.onTableRowClick = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.dataSource = new BehaviorSubject<any>(null);
    this.showPaginator = new BehaviorSubject<boolean>(true);
    this.selectedRowIndex = new BehaviorSubject<number>(null);
  }

  ngOnDestroy() {
    this.dataSource.unsubscribe();
    this.showPaginator.unsubscribe();
    this.selectedRowIndex.unsubscribe();
    if (this.exchangeUnsubscribe) {
      this.exchangeUnsubscribe.unsubscribe();
    }
  }

  ngOnInit() {
    this.userDefinedApps = this._getApps$();
    this.assignData(this.userDefinedApps);
    this.exchangeUnsubscribe = this.exchange.registerInterest(
      'apps-filter',
      this.addSelectedAppsList.bind(this)
    );
    this.child.selection.changed.subscribe(() => {
      this.selectedRow();
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  assignData(data: any): void {
    this.userDefinedAppList = this.transformService.transformData(
      'user-application-management',
      data
    );
    this.dataSource.next(this.userDefinedAppList);
    this.appList = cloneDeep(this.userDefinedAppList);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  onSearchTextChange(searchText: any): any {
    searchText = searchText.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.userDefinedAppList.data = filter(this.appList.data, (item: any) => {
      if (item.name.toLowerCase().indexOf(searchText) >= 0) {
        return item;
      }
    });
    this.dataSource.next(this.userDefinedAppList);
  }

  selectedRow(): void {
    const selectedRows = this.getSelectedItems();
    this.onDataValueChange.emit({
      componentId: 'user_app_selection',
      key: 'selectedApps',
      newValue: selectedRows,
      isValid: selectedRows.length > 0
    });
  }

  getSelectedItems(): Array<string> {
    return get(this, 'child.selection.selected', []).map(item => {
      const appDetails = this.userDefinedApps.find(value => value.applicationData.id === item);
      return {
        appId: item,
        name: appDetails.escapedName,
        minimumSeverity: ISeverityEnum.WARNING
      };
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  addSelectedAppsList(apps: IAlertListRow[] = []): any {
    if (!apps.length) {
      return;
    }
    const uniqueAppIds = uniq(apps.map(app => app.appId));
    this.userDefinedAppList.data = this.userDefinedAppList.data.filter(
      app => !uniqueAppIds.includes(app.id)
    );
    this.dataSource.next(this.userDefinedAppList);
    this.appList = cloneDeep(this.userDefinedAppList);
  }

  private _getApps$() {
    this.timeout.set(
      'userAppSelection',
      () => {
        this.onDataValueChange.emit({
          componentId: 'user_app_selection',
          key: 'selectedApps',
          newValue: {},
          isValid: false
        });
      },
      0
    );
    const allApps = this.applicationsService.getValues();
    return this.applicationsService.getUserDefinedAppsOnly(allApps);
  }
}
